/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ActivityDetails } from "./ActivityDetails";
import type { app__services__Automations__messages__automations__PersonRef } from "./app__services__Automations__messages__automations__PersonRef";
import type { Auth0AccountRole } from "./Auth0AccountRole";
import type { CardCrm } from "./CardCrm";
import type { CardMessage } from "./CardMessage";
import type { CardTask } from "./CardTask";

/**
 * Something an automation does that waits for a person to approve it (Ask
 * first): its automation, what it does in words, who it is about, and the
 * task or message it would make.
 */
export type AutomationCard = {
  id: string;
  automation_id?: number | null;
  automation_name?: string | null;
  step_id?: number | null;
  action: string;
  label: string;
  button: string;
  person_type?: Auth0AccountRole | null;
  person_id?: number | null;
  person_name?: string | null;
  note?: string | null;
  created_at: string;
  task?: CardTask | null;
  message?: CardMessage | null;
  crm?: CardCrm | null;
  run_key?: string | null;
  approver_roles?: AutomationCard.approver_roles;
  actor?: app__services__Automations__messages__automations__PersonRef | null;
  asked?: Array<app__services__Automations__messages__automations__PersonRef>;
  cause?: string | null;
  due_at?: string | null;
  preview?: ActivityDetails | null;
};

export namespace AutomationCard {
  export enum approver_roles {
    ADMIN = "admin",
    TUTOR = "tutor",
    BOTH = "both",
  }
}
